// Vendor Libs
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash.isempty';
import filter from 'lodash.filter'; // DishTech React

import { actions } from '@dishtech-react/redux';
var _registerForm = actions.registerForm,
    _resetForm = actions.resetForm,
    _setFieldValue = actions.setFieldValue,
    _setFieldValues = actions.setFieldValues,
    _submitForm = actions.submitForm,
    _unregisterForm = actions.unregisterForm;
export var useForm = function useForm(serviceConfig, formKey, mode) {
  if (mode === void 0) {
    mode = 'create';
  }

  var dispatch = useDispatch();
  var formKeyForOperation = mode.toUpperCase() + "_" + formKey;
  return {
    formValid: useSelector(function (_ref) {
      var _ref$form = _ref.form;
      _ref$form = _ref$form === void 0 ? {} : _ref$form;
      var _ref$form$formKeyForO = _ref$form[formKeyForOperation];
      _ref$form$formKeyForO = _ref$form$formKeyForO === void 0 ? {} : _ref$form$formKeyForO;
      var _ref$form$formKeyForO2 = _ref$form$formKeyForO.fieldErrors,
          fieldErrors = _ref$form$formKeyForO2 === void 0 ? {} : _ref$form$formKeyForO2;
      return isEmpty(filter(fieldErrors, function (value) {
        return value;
      }));
    }),
    formValues: useSelector(function (_ref2) {
      var _ref2$form = _ref2.form;
      _ref2$form = _ref2$form === void 0 ? {} : _ref2$form;
      var _ref2$form$formKeyFor = _ref2$form[formKeyForOperation];
      _ref2$form$formKeyFor = _ref2$form$formKeyFor === void 0 ? {} : _ref2$form$formKeyFor;
      var _ref2$form$formKeyFor2 = _ref2$form$formKeyFor.values,
          values = _ref2$form$formKeyFor2 === void 0 ? {} : _ref2$form$formKeyFor2;
      return values;
    }),
    formFieldErrors: useSelector(function (_ref3) {
      var _ref3$form = _ref3.form;
      _ref3$form = _ref3$form === void 0 ? {} : _ref3$form;
      var _ref3$form$formKeyFor = _ref3$form[formKeyForOperation];
      _ref3$form$formKeyFor = _ref3$form$formKeyFor === void 0 ? {} : _ref3$form$formKeyFor;
      var _ref3$form$formKeyFor2 = _ref3$form$formKeyFor.fieldErrors,
          fieldErrors = _ref3$form$formKeyFor2 === void 0 ? {} : _ref3$form$formKeyFor2;
      return fieldErrors;
    }),
    registerForm: function registerForm() {
      return dispatch(_registerForm(formKeyForOperation));
    },
    setFieldValue: function setFieldValue() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return dispatch(_setFieldValue.apply(void 0, [formKeyForOperation].concat(args)));
    },
    setFieldValues: function setFieldValues() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return dispatch(_setFieldValues.apply(void 0, [formKeyForOperation].concat(args)));
    },
    unregisterForm: function unregisterForm() {
      return dispatch(_unregisterForm(formKeyForOperation));
    },
    resetForm: function resetForm() {
      return dispatch(_resetForm(formKeyForOperation));
    },
    submitForm: function submitForm() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return dispatch(_submitForm.apply(void 0, [serviceConfig, formKeyForOperation].concat(args)));
    }
  };
};